import { render, staticRenderFns } from "./PendingEditRequestTextValues.vue?vue&type=template&id=3c02fe56&"
import script from "./PendingEditRequestTextValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestTextValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports